import React, { Component } from 'react'
// import './App.css';
import Mainindex from './screens/Mainindex/Mainindex'
//import { Router, Route, Switch } from 'react-router-dom';
import { 
  HashRouter as Router,
  Route,
} from 'react-router-dom';
//import { Router } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory'
import Routes from './libs/routes.js'

//import TagManager from 'react-gtm-module'; // Goole Tag Manager module
import Cache from './Cache';
import { Config } from './Config';
/*
const tagManagerArgs = {
  gtmId: 'GTM-MX2RG6H',
  dataLayer: {
    project: 'webappsci',
  }
}; // Goole Tag Manager Id

TagManager.initialize(tagManagerArgs);
*/
const newHistory = createBrowserHistory();

class App extends Component {

  constructor(props) {
    super(props);

    let params = null;
    console.log('[App]', params);
    console.log('[VERSION]', Config.version);

    this.state = {
      login: false,
      isertInfo: false,
    };

  }

  render() {
    return (
      <Cache>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            // we can decide how and when we want to force reload
            refreshCacheAndReload()
          }
          return (
            <Router history={newHistory}>
              <Routes />
            </Router>
          )
        }}
      </Cache>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js